module.exports = __webpack_public_path__ + "static/allteam-e627bdbaa6d0a88a741836369ef00a90.png";